/* eslint-disable no-console */

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => registration.unregister())
    })
    .catch((error) => {
      console.error('Error while unregistering service workers:', error)
    })
}


